import { render, staticRenderFns } from "./ShotDetection.vue?vue&type=template&id=ac80c75a&"
import script from "./ShotDetection.vue?vue&type=script&lang=js&"
export * from "./ShotDetection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports